

const PageHeader = ({pageName, imageUrl, children}) => {
  const headerImage = {
    backgroundImage: `url(${imageUrl})`,
  } 

  return (
    <header className={`page__header ${pageName}__header`} style={headerImage}>
        <div className={`container header__container ${pageName}-header__container`}>
          {children}
        </div>
    </header>
  )
}

export default PageHeader

// <PageHeader/>

// import PageHeader from '../PageHeader'
// import Image from '../../images/header-{pagename}.png'

// return (
//   <>
//     <PageHeader pageName="" imageUrl={Image}>
//       children go here
//     </PageHeader>
//   </>
// )